import ons from "onsenui";

export default function platformDefaultAnimation() {
  return ons.platform.isAndroid() ? "lift" : "slide";
}
